<template>
  <div class="add-wallet">
    <div class="add-wallet-title">添加钱包</div>
    <div class="add-wallet-contet">
      <div class="contet-top">
        <img src="@/styles/images/ADD_NEW.png" alt="" />
        <div>
          <div class="titles" @click="jumpPage('/createWallet')">创建新钱包</div>
          <div class="decs">创建一个全新的钱包</div>
        </div>
      </div>
      <div class="contet-btm">
        <img src="@/styles/images/ADD_daoru.png" alt="" />
        <div>
          <div class="titles" @click="jumpPage('/importWallet')">导入已有钱包</div>
          <div class="decs">通过已有的钱包助记词导入钱包</div>
        </div>
      </div>
      <div class="contet-btm" v-if="isinapp && !isIndependent">
        <img src="@/styles/images/Notice_fail.png" alt="" />
        <div>
          <div class="titles" @click="exit()">返回商城</div>
          <div class="decs">注意：请及时创建钱包以便接收{{ unit }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      unit: process.env.chain_unit,
      isIndependent: process.env.isIndependent
    }
  },
  computed: {
    isinapp () {
      return this.$store.state.app.isinapp
    }
  },
  methods: {
    jumpPage (router) {
      this.$router.push({ path: router })
    },
    exit () {
      this.$toast.loading('退出钱包...')
      if (this.isinapp) {
        console.log('电商APP内退出钱包')
        window.closeWallet(process.env.EC_URL)
        // 如果是电商APP进入
        this.$toast.hide()
      } else if (this.$store.state.app.platform == 'app') {
        // APP
        console.log('独立APP内退出钱包')
        navigator.app.exitApp()
        this.$toast.hide()
      } else {
        this.$toast.hide()
        // H5
        console.log('H5内退出钱包')
        this.$router.replace({ path: '/' })
      }
    }
  },
  created () {
    if (window.history && window.history.pushState) {
      // 向历史记录中插入了当前页
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.exit, false)
    }
  },
  destroyed () {
    window.removeEventListener('popstate', this.exit, false)
  }
}
</script>

<style scoped>
.add-wallet-title {
  font-size: 0.53rem;
  color: var(--fontColor);
  padding: 1rem 0.36rem 0.36rem;
}

.add-wallet-contet {
  height: 3.55rem;
  margin: 1.2rem 0 0 0.4rem;
  display: flex;
  flex-wrap: wrap;
}

.contet-top,
.contet-btm {
  width: 100%;
  height: 1.4rem;
  display: flex;
  margin-bottom: 0.52rem;
}

.contet-top {
  margin-bottom: 0.52rem;
}

.add-wallet-contet img {
  width: 1.17rem;
  height: 1.17rem;
  margin-top: 0.11rem;
  margin-right: 0.4rem;
}

.add-wallet-contet .titles {
  font-size: 0.53rem;
  font-weight: normal;
}

.add-wallet-contet .decs {
  font-size: 0.35rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.94rem;
  letter-spacing: 0rem;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/views/create/addWallet.vue